module.exports = __webpack_public_path__ + "img/img_no_permission.e64eaa8b.png";